// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import Tips from './Tips';

import '../../styles/modal.css';
import '../../styles/tips.css';

export default class DocumentTips extends Tips {

    renderContent = () => {
        return (<div className="modal-content modal-center">
            {this.state.stage === 0 ? <>
                <h1>You've opened a document!</h1>
                Stax<div className="navigation-logo-dot" />ai <strong>reads</strong> your documents (even scanned and faxed ones!) and <strong>indexes</strong> the text content for you.<br />
                It also <strong>extracts</strong> some useful information like keywords, urgency, and intent.<br /><br /><br />
                <img
                    style={{ width: 300 }}
                    src="https://static.stax.ai/images/graphics/guide-document-search.png"
                    alt="Document searching"
                /><br /><br />
                Use the <u>Search bar</u> on the top-right corner to search for content <strong>within</strong> the document.<br />
                Results will be highlighted and you can scroll through them.
                <br />
                <div className="welcome-next" onClick={this.nextStage}>Next ⇾</div>
            </> :
            
            this.state.stage === 1 ? <>
                <h1>Taking notes</h1>
                Move your mouse to the bottom of the screen to see the <u>document toolbar</u>.<br />
                You can use the toolbar to zoom or access <strong>canvas</strong> functionality.
                <br /><br />
                <img
                    style={{ width: 240 }}
                    src="https://static.stax.ai/images/graphics/guide-document-canvas.png"
                    alt="Document toolbar"
                /><br /><br />
                You can draw notes on the documents, type text, or erase your notes.<br />
                Using the <u>select</u> tool, you can also select and copy text out of the document.
                <br />
                <div className="welcome-next" onClick={this.nextStage}>Next ⇾</div>
            </> :
            
            this.state.stage === 2 ? <>
                <h1>More options...</h1>
                <strong>Right-click</strong> on a document to see more options like archiving, sending, moving, renaming, printing, and more!
                <br /><br />
                <img
                    style={{ width: 240 }}
                    src="https://static.stax.ai/images/graphics/guide-document-options.png"
                    alt="Document options"
                /><br /><br />
                The document's <strong>meta</strong> data can be found the right side.<br />
                You can assign documents to your teammates using the dropdown menu under <u>Sharing</u> and find other operations under <u>Actions</u>.<br />
                <div className="welcome-next" onClick={this.props.close}>Got it!</div>
            </> : ""}
        </div>);
    }

};